enum localStorageEnum {
	user = 'user',
	residences = 'residences',
	buildings = 'buildings',
	mainBuilding = 'mainBuilding',
	commonUri = 'commonUri',
	language = 'language',
	oktaToken = 'okta-token-storage',
	step = 'step',
	selectedLots = 'selectedLots',
	derniereDemande = 'derniereDemande'
}

export default localStorageEnum